(function(global){
"use strict";
var THREE={ REVISION:"SQ3D-1" };
function Vector3(x,y,z){ this.x=x||0; this.y=y||0; this.z=z||0; }
Vector3.prototype={
constructor:Vector3,
set:function(x,y,z){ this.x=x; this.y=y; this.z=z; return this; },
setScalar:function(s){ return this.set(s,s,s); },
clone:function(){ return new Vector3(this.x,this.y,this.z); },
copy:function(v){ return this.set(v.x,v.y,v.z); },
add:function(v){ this.x+=v.x; this.y+=v.y; this.z+=v.z; return this; },
sub:function(v){ this.x-=v.x; this.y-=v.y; this.z-=v.z; return this; },
multiplyScalar:function(s){ this.x*=s; this.y*=s; this.z*=s; return this; },
length:function(){ return Math.sqrt(this.x*this.x+this.y*this.y+this.z*this.z); },
normalize:function(){ var l=this.length()||1; return this.multiplyScalar(1/l); },
dot:function(v){ return this.x*v.x+this.y*v.y+this.z*v.z; },
cross:function(v){ var x=this.x,y=this.y,z=this.z;
this.x=y*v.z-z*v.y; this.y=z*v.x-x*v.z; this.z=x*v.y-y*v.x; return this; },
crossVectors:function(a,b){ this.x=a.y*b.z-a.z*b.y; this.y=a.z*b.x-a.x*b.z; this.z=a.x*b.y-a.y*b.x; return this; },
subVectors:function(a,b){ this.x=a.x-b.x; this.y=a.y-b.y; this.z=a.z-b.z; return this; },
applyQuaternion:function(q){
var x=this.x,y=this.y,z=this.z, qx=q.x,qy=q.y,qz=q.z,qw=q.w;
var ix=qw*x+qy*z-qz*y, iy=qw*y+qz*x-qx*z, iz=qw*z+qx*y-qy*x, iw=-qx*x-qy*y-qz*z;
this.x=ix*qw+iw*-qx+iy*-qz-iz*-qy;
this.y=iy*qw+iw*-qy+iz*-qx-ix*-qz;
this.z=iz*qw+iw*-qz+ix*-qy-iy*-qx;
return this;
},
applyAxisAngle:function(axis,angle){
return this.applyQuaternion(new Quaternion().setFromAxisAngle(axis,angle));
},
applyMatrix4:function(m){
var e=m.e, x=this.x,y=this.y,z=this.z;
var w=1/((e[3]*x+e[7]*y+e[11]*z+e[15])||1);
this.x=(e[0]*x+e[4]*y+e[8]*z+e[12])*w;
this.y=(e[1]*x+e[5]*y+e[9]*z+e[13])*w;
this.z=(e[2]*x+e[6]*y+e[10]*z+e[14])*w;
return this;
}
};
THREE.Vector3=Vector3;
function Quaternion(x,y,z,w){ this.x=x||0; this.y=y||0; this.z=z||0; this.w=(w===undefined)?1:w; }
Quaternion.prototype={
constructor:Quaternion,
set:function(x,y,z,w){ this.x=x;this.y=y;this.z=z;this.w=w; return this; },
clone:function(){ return new Quaternion(this.x,this.y,this.z,this.w); },
copy:function(q){ return this.set(q.x,q.y,q.z,q.w); },
identity:function(){ return this.set(0,0,0,1); },
normalize:function(){ var l=Math.sqrt(this.x*this.x+this.y*this.y+this.z*this.z+this.w*this.w)||1;
this.x/=l;this.y/=l;this.z/=l;this.w/=l; return this; },
setFromAxisAngle:function(axis,angle){
var h=angle/2, s=Math.sin(h);
return this.set(axis.x*s,axis.y*s,axis.z*s,Math.cos(h));
},
setFromEuler:function(x,y,z){
var c1=Math.cos(x/2),c2=Math.cos(y/2),c3=Math.cos(z/2);
var s1=Math.sin(x/2),s2=Math.sin(y/2),s3=Math.sin(z/2);
this.x=s1*c2*c3+c1*s2*s3;
this.y=c1*s2*c3-s1*c2*s3;
this.z=c1*c2*s3+s1*s2*c3;
this.w=c1*c2*c3-s1*s2*s3;
return this;
},
setFromUnitVectors:function(from,to){
var r=from.dot(to)+1;
if(r<1e-8){
r=0;
if(Math.abs(from.x)>Math.abs(from.z)) this.set(-from.y,from.x,0,r);
else this.set(0,-from.z,from.y,r);
}else{
this.set(from.y*to.z-from.z*to.y, from.z*to.x-from.x*to.z, from.x*to.y-from.y*to.x, r);
}
return this.normalize();
},
multiplyQuaternions:function(a,b){
var ax=a.x,ay=a.y,az=a.z,aw=a.w, bx=b.x,by=b.y,bz=b.z,bw=b.w;
this.x=ax*bw+aw*bx+ay*bz-az*by;
this.y=ay*bw+aw*by+az*bx-ax*bz;
this.z=az*bw+aw*bz+ax*by-ay*bx;
this.w=aw*bw-ax*bx-ay*by-az*bz;
return this;
},
multiply:function(q){ return this.multiplyQuaternions(this,q); },
premultiply:function(q){ return this.multiplyQuaternions(q,this); },
setFromBasis:function(xa,ya,za){
var m00=xa.x,m01=ya.x,m02=za.x, m10=xa.y,m11=ya.y,m12=za.y, m20=xa.z,m21=ya.z,m22=za.z;
var tr=m00+m11+m22, s;
if(tr>0){ s=0.5/Math.sqrt(tr+1); this.w=0.25/s; this.x=(m21-m12)*s; this.y=(m02-m20)*s; this.z=(m10-m01)*s; }
else if(m00>m11&&m00>m22){ s=2*Math.sqrt(1+m00-m11-m22); this.w=(m21-m12)/s; this.x=0.25*s; this.y=(m01+m10)/s; this.z=(m02+m20)/s; }
else if(m11>m22){ s=2*Math.sqrt(1+m11-m00-m22); this.w=(m02-m20)/s; this.x=(m01+m10)/s; this.y=0.25*s; this.z=(m12+m21)/s; }
else{ s=2*Math.sqrt(1+m22-m00-m11); this.w=(m10-m01)/s; this.x=(m02+m20)/s; this.y=(m12+m21)/s; this.z=0.25*s; }
return this;
}
};
THREE.Quaternion=Quaternion;
function Matrix4(){ this.e=new Float32Array([1,0,0,0, 0,1,0,0, 0,0,1,0, 0,0,0,1]); }
Matrix4.prototype={
constructor:Matrix4,
identity:function(){ var e=this.e; e.set([1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1]); return this; },
copy:function(m){ this.e.set(m.e); return this; },
clone:function(){ return new Matrix4().copy(this); },
compose:function(p,q,s){
var e=this.e, x=q.x,y=q.y,z=q.z,w=q.w;
var x2=x+x,y2=y+y,z2=z+z;
var xx=x*x2,xy=x*y2,xz=x*z2, yy=y*y2,yz=y*z2,zz=z*z2, wx=w*x2,wy=w*y2,wz=w*z2;
var sx=s.x,sy=s.y,sz=s.z;
e[0]=(1-(yy+zz))*sx; e[1]=(xy+wz)*sx; e[2]=(xz-wy)*sx; e[3]=0;
e[4]=(xy-wz)*sy; e[5]=(1-(xx+zz))*sy; e[6]=(yz+wx)*sy; e[7]=0;
e[8]=(xz+wy)*sz; e[9]=(yz-wx)*sz; e[10]=(1-(xx+yy))*sz; e[11]=0;
e[12]=p.x; e[13]=p.y; e[14]=p.z; e[15]=1;
return this;
},
multiplyMatrices:function(A,B){
var a=A.e,b=B.e,e=this.e, t=new Float32Array(16);
for(var i=0;i<4;i++)for(var j=0;j<4;j++){
t[j*4+i]=a[i]*b[j*4]+a[4+i]*b[j*4+1]+a[8+i]*b[j*4+2]+a[12+i]*b[j*4+3];
}
e.set(t); return this;
},
makePerspective:function(fovDeg,aspect,near,far){
var e=this.e, f=1/Math.tan(fovDeg*Math.PI/360);
e.set([f/aspect,0,0,0, 0,f,0,0, 0,0,(far+near)/(near-far),-1, 0,0,2*far*near/(near-far),0]);
return this;
}
};
THREE.Matrix4=Matrix4;
function Color(hex){ this.setHex(hex===undefined?0xffffff:hex); }
Color.prototype={
constructor:Color,
setHex:function(h){
if(h instanceof Color){ this.r=h.r; this.g=h.g; this.b=h.b; return this; }
this.r=((h>>16)&255)/255; this.g=((h>>8)&255)/255; this.b=(h&255)/255; return this;
}
};
THREE.Color=Color;
function Box3(){ this.min=new Vector3(Infinity,Infinity,Infinity); this.max=new Vector3(-Infinity,-Infinity,-Infinity); }
Box3.prototype={
constructor:Box3,
setFromObject:function(obj){
var self=this;
obj.updateWorldMatrix(null);
obj.traverse(function(o){
if(!o.geometry) return;
var pos=o.geometry.attributes.position; if(!pos) return;
var a=pos.array, e=o.matrixWorld.e;
for(var i=0;i<a.length;i+=3){
var x=a[i],y=a[i+1],z=a[i+2];
var wx=e[0]*x+e[4]*y+e[8]*z+e[12];
var wy=e[1]*x+e[5]*y+e[9]*z+e[13];
var wz=e[2]*x+e[6]*y+e[10]*z+e[14];
if(wx<self.min.x)self.min.x=wx; if(wx>self.max.x)self.max.x=wx;
if(wy<self.min.y)self.min.y=wy; if(wy>self.max.y)self.max.y=wy;
if(wz<self.min.z)self.min.z=wz; if(wz>self.max.z)self.max.z=wz;
}
});
return this;
},
getCenter:function(t){
t.set((this.min.x+this.max.x)/2,(this.min.y+this.max.y)/2,(this.min.z+this.max.z)/2);
return t;
}
};
THREE.Box3=Box3;
var _oid=0;
function Object3D(){
this.id=_oid++;
this.position=new Vector3();
this.scale=new Vector3(1,1,1);
this.quaternion=new Quaternion();
var self=this;
this.rotation={ _x:0,_y:0,_z:0,
get x(){return this._x;}, set x(v){this._x=v; self._eulerDirty=true;},
get y(){return this._y;}, set y(v){this._y=v; self._eulerDirty=true;},
get z(){return this._z;}, set z(v){this._z=v; self._eulerDirty=true;}
};
this._eulerDirty=false;
this.children=[];
this.parent=null;
this.visible=true;
this.castShadow=false;
this.receiveShadow=false;
this.userData={};
this.matrixWorld=new Matrix4();
this._local=new Matrix4();
}
Object3D.prototype={
constructor:Object3D,
add:function(o){ o.parent=this; this.children.push(o); return this; },
remove:function(o){ var i=this.children.indexOf(o); if(i>=0){ this.children.splice(i,1); o.parent=null; } return this; },
traverse:function(fn){ fn(this); for(var i=0;i<this.children.length;i++) this.children[i].traverse(fn); },
rotateX:function(a){ this.quaternion.multiply(new Quaternion().setFromAxisAngle(new Vector3(1,0,0),a)); this._eulerBypass=true; return this; },
rotateY:function(a){ this.quaternion.multiply(new Quaternion().setFromAxisAngle(new Vector3(0,1,0),a)); this._eulerBypass=true; return this; },
lookAt:function(t){
var target=(t instanceof Vector3)?t:new Vector3(t,arguments[1],arguments[2]);
var z=new Vector3().subVectors(target,this.position).normalize();
if(this.isCamera) z.multiplyScalar(-1);
var up=new Vector3(0,1,0);
var x=new Vector3().crossVectors(up,z);
if(x.length()<1e-6){ x.set(1,0,0); } else x.normalize();
var y=new Vector3().crossVectors(z,x);
this.quaternion.setFromBasis(x,y,z);
this._eulerBypass=true; this._eulerDirty=false;
return this;
},
updateLocal:function(){
if(this._eulerDirty && !this._eulerBypass){
this.quaternion.setFromEuler(this.rotation._x,this.rotation._y,this.rotation._z);
}else if(this._eulerDirty && this._eulerBypass){
this.quaternion.setFromEuler(this.rotation._x,this.rotation._y,this.rotation._z);
}
this._eulerDirty=false;
if(!this._eulerBypass && (this.rotation._x||this.rotation._y||this.rotation._z)){
this.quaternion.setFromEuler(this.rotation._x,this.rotation._y,this.rotation._z);
}
this._local.compose(this.position,this.quaternion,this.scale);
},
updateWorldMatrix:function(parentMatrix){
this.updateLocal();
if(parentMatrix) this.matrixWorld.multiplyMatrices(parentMatrix,this._local);
else this.matrixWorld.copy(this._local);
for(var i=0;i<this.children.length;i++) this.children[i].updateWorldMatrix(this.matrixWorld);
}
};
THREE.Object3D=Object3D;
function Group(){ Object3D.call(this); }
Group.prototype=Object.create(Object3D.prototype); Group.prototype.constructor=Group;
THREE.Group=Group;
function Scene(){ Object3D.call(this); this.environment=null; this.background=null; }
Scene.prototype=Object.create(Object3D.prototype); Scene.prototype.constructor=Scene;
THREE.Scene=Scene;
function Mesh(geometry,material){ Object3D.call(this); this.geometry=geometry; this.material=material; this.isMesh=true; }
Mesh.prototype=Object.create(Object3D.prototype); Mesh.prototype.constructor=Mesh;
THREE.Mesh=Mesh;
function InstancedMesh(geometry,material,count){
Mesh.call(this,new BufferGeometry(),material);
this._srcGeo=geometry; this._count=count;
this._mats=new Array(count);
var self=this;
this.instanceMatrix={ _n:false,
get needsUpdate(){ return this._n; },
set needsUpdate(v){ this._n=v; if(v) self._bake(); }
};
}
InstancedMesh.prototype=Object.create(Mesh.prototype);
InstancedMesh.prototype.constructor=InstancedMesh;
InstancedMesh.prototype.setMatrixAt=function(i,m){ this._mats[i]=m.clone(); };
InstancedMesh.prototype._bake=function(){
var src=this._srcGeo.attributes.position.array;
var n=src.length, out=new Float32Array(n*this._count);
for(var k=0;k<this._count;k++){
var m=this._mats[k]; if(!m) continue;
var e=m.e, o=k*n;
for(var i=0;i<n;i+=3){
var x=src[i],y=src[i+1],z=src[i+2];
out[o+i]  =e[0]*x+e[4]*y+e[8]*z+e[12];
out[o+i+1]=e[1]*x+e[5]*y+e[9]*z+e[13];
out[o+i+2]=e[2]*x+e[6]*y+e[10]*z+e[14];
}
}
this.geometry.dispose();
this.geometry=new BufferGeometry();
this.geometry.setAttribute("position",new Float32BufferAttribute(out,3));
this.geometry.computeVertexNormals();
};
THREE.InstancedMesh=InstancedMesh;
function Light(color,intensity){ Object3D.call(this); this.color=new Color(color); this.intensity=intensity===undefined?1:intensity; this.isLight=true; }
Light.prototype=Object.create(Object3D.prototype); Light.prototype.constructor=Light;
function SpotLight(c,i){ Light.call(this,c,i); this.isSpot=true; this.angle=0.5; this.penumbra=0; this.decay=1;
this.shadow={ mapSize:{set:function(){}}, bias:0, camera:{near:0.1,far:100} }; }
SpotLight.prototype=Object.create(Light.prototype); SpotLight.prototype.constructor=SpotLight;
function DirectionalLight(c,i){ Light.call(this,c,i); this.isDir=true; }
DirectionalLight.prototype=Object.create(Light.prototype); DirectionalLight.prototype.constructor=DirectionalLight;
function PointLight(c,i,dist,decay){ Light.call(this,c,i); this.isPoint=true; this.distance=dist||0; this.decay=decay===undefined?1:decay; }
PointLight.prototype=Object.create(Light.prototype); PointLight.prototype.constructor=PointLight;
function AmbientLight(c,i){ Light.call(this,c,i); this.isAmbient=true; }
AmbientLight.prototype=Object.create(Light.prototype); AmbientLight.prototype.constructor=AmbientLight;
THREE.SpotLight=SpotLight; THREE.DirectionalLight=DirectionalLight;
THREE.PointLight=PointLight; THREE.AmbientLight=AmbientLight;
function PerspectiveCamera(fov,aspect,near,far){
Object3D.call(this);
this.isCamera=true;
this.fov=fov||50; this.aspect=aspect||1; this.near=near||0.1; this.far=far||2000;
this.projection=new Matrix4();
}
PerspectiveCamera.prototype=Object.create(Object3D.prototype);
PerspectiveCamera.prototype.constructor=PerspectiveCamera;
PerspectiveCamera.prototype.updateProjectionMatrix=function(){
this.projection.makePerspective(this.fov,this.aspect,this.near,this.far);
};
THREE.PerspectiveCamera=PerspectiveCamera;
function Float32BufferAttribute(arr,itemSize){
this.array=(arr instanceof Float32Array)?arr:new Float32Array(arr);
this.itemSize=itemSize;
}
THREE.Float32BufferAttribute=Float32BufferAttribute;
var _gid=0;
function BufferGeometry(){ this.gid=_gid++; this.attributes={}; this.index=null; this._version=0; }
BufferGeometry.prototype={
constructor:BufferGeometry,
setAttribute:function(name,attr){ this.attributes[name]=attr; this._version++; return this; },
setIndex:function(idx){ this.index=(idx&&idx.length!==undefined)?idx:idx; this._version++; return this; },
dispose:function(){ this._disposed=true; },
computeVertexNormals:function(){
var pos=this.attributes.position.array;
var nrm=new Float32Array(pos.length);
function acc(ia,ib,ic){
var ax=pos[ia],ay=pos[ia+1],az=pos[ia+2];
var bx=pos[ib],by=pos[ib+1],bz=pos[ib+2];
var cx=pos[ic],cy=pos[ic+1],cz=pos[ic+2];
var ux=bx-ax,uy=by-ay,uz=bz-az, vx=cx-ax,vy=cy-ay,vz=cz-az;
var nx=uy*vz-uz*vy, ny=uz*vx-ux*vz, nz=ux*vy-uy*vx;
nrm[ia]+=nx;nrm[ia+1]+=ny;nrm[ia+2]+=nz;
nrm[ib]+=nx;nrm[ib+1]+=ny;nrm[ib+2]+=nz;
nrm[ic]+=nx;nrm[ic+1]+=ny;nrm[ic+2]+=nz;
}
if(this.index){
var ix=this.index;
for(var i=0;i<ix.length;i+=3) acc(ix[i]*3,ix[i+1]*3,ix[i+2]*3);
}else{
for(var j=0;j<pos.length;j+=9) acc(j,j+3,j+6);
}
for(var k=0;k<nrm.length;k+=3){
var l=Math.sqrt(nrm[k]*nrm[k]+nrm[k+1]*nrm[k+1]+nrm[k+2]*nrm[k+2])||1;
nrm[k]/=l;nrm[k+1]/=l;nrm[k+2]/=l;
}
this.setAttribute("normal",new Float32BufferAttribute(nrm,3));
return this;
}
};
THREE.BufferGeometry=BufferGeometry;
function paramGeometry(build){
var g=new BufferGeometry(), pos=[],uv=[],idx=[];
build(pos,uv,idx);
g.setAttribute("position",new Float32BufferAttribute(pos,3));
if(uv.length) g.setAttribute("uv",new Float32BufferAttribute(uv,2));
if(idx.length) g.setIndex(idx);
g.computeVertexNormals();
return g;
}
THREE.PlaneGeometry=function(w,h){
return paramGeometry(function(pos,uv,idx){
var hw=w/2,hh=h/2;
pos.push(-hw,-hh,0, hw,-hh,0, hw,hh,0, -hw,hh,0);
uv.push(0,0, 1,0, 1,1, 0,1);
idx.push(0,1,2, 0,2,3);
});
};
THREE.BoxGeometry=function(w,h,d){
w=w||1;h=h||1;d=d||1;
return paramGeometry(function(pos,uv,idx){
var x=w/2,y=h/2,z=d/2;
var faces=[
[[ x,-y,-z],[ x, y,-z],[ x, y, z],[ x,-y, z]],
[[-x,-y, z],[-x, y, z],[-x, y,-z],[-x,-y,-z]],
[[-x, y,-z],[-x, y, z],[ x, y, z],[ x, y,-z]],
[[-x,-y, z],[-x,-y,-z],[ x,-y,-z],[ x,-y, z]],
[[-x,-y, z],[ x,-y, z],[ x, y, z],[-x, y, z]],
[[ x,-y,-z],[-x,-y,-z],[-x, y,-z],[ x, y,-z]]
];
for(var f=0;f<6;f++){
var b=pos.length/3;
for(var v=0;v<4;v++){ pos.push(faces[f][v][0],faces[f][v][1],faces[f][v][2]); uv.push(v===1||v===2?1:0, v>=2?1:0); }
idx.push(b,b+1,b+2, b,b+2,b+3);
}
});
};
THREE.SphereGeometry=function(r,ws,hs){
ws=ws||12; hs=hs||8;
return paramGeometry(function(pos,uv,idx){
for(var y=0;y<=hs;y++){
var v=y/hs, phi=v*Math.PI;
for(var x=0;x<=ws;x++){
var u=x/ws, th=u*Math.PI*2;
pos.push(-r*Math.cos(th)*Math.sin(phi), r*Math.cos(phi), r*Math.sin(th)*Math.sin(phi));
uv.push(u,1-v);
}
}
for(var y2=0;y2<hs;y2++)for(var x2=0;x2<ws;x2++){
var a=y2*(ws+1)+x2, b=a+ws+1;
idx.push(a,b,a+1, b,b+1,a+1);
}
});
};
THREE.CylinderGeometry=function(rt,rb,h,seg){
seg=seg||12;
return paramGeometry(function(pos,uv,idx){
for(var y=0;y<=1;y++){
var r=y?rt:rb, yy=y?h/2:-h/2;
for(var i=0;i<=seg;i++){
var a=i/seg*Math.PI*2;
pos.push(r*Math.sin(a),yy,r*Math.cos(a)); uv.push(i/seg,y);
}
}
for(var i2=0;i2<seg;i2++){
var a2=i2, b=i2+seg+1;
idx.push(a2,a2+1,b, a2+1,b+1,b);
}
[ [rb,-h/2,-1], [rt,h/2,1] ].forEach(function(cap){
if(cap[0]<=0.0001) return;
var base=pos.length/3;
pos.push(0,cap[1],0); uv.push(0.5,0.5);
for(var i3=0;i3<=seg;i3++){
var a3=i3/seg*Math.PI*2;
pos.push(cap[0]*Math.sin(a3),cap[1],cap[0]*Math.cos(a3)); uv.push(0.5,0.5);
}
for(var i4=0;i4<seg;i4++){
if(cap[2]>0) idx.push(base,base+1+i4,base+2+i4);
else idx.push(base,base+2+i4,base+1+i4);
}
});
});
};
THREE.TorusGeometry=function(R,r,rs,ts){
rs=rs||8; ts=ts||32;
return paramGeometry(function(pos,uv,idx){
for(var j=0;j<=rs;j++){
var v=j/rs*Math.PI*2;
for(var i=0;i<=ts;i++){
var u=i/ts*Math.PI*2;
pos.push((R+r*Math.cos(v))*Math.cos(u),(R+r*Math.cos(v))*Math.sin(u),r*Math.sin(v));
uv.push(i/ts,j/rs);
}
}
for(var j2=0;j2<rs;j2++)for(var i2=0;i2<ts;i2++){
var a=j2*(ts+1)+i2, b=(j2+1)*(ts+1)+i2;
idx.push(a,b,a+1, b,b+1,a+1);
}
});
};
function Curve(){}
Curve.prototype.getPoint=function(){ return new Vector3(); };
THREE.Curve=Curve;
function CatmullRomCurve3(points,closed){
Curve.call(this); this.points=points; this.closed=!!closed;
}
CatmullRomCurve3.prototype=Object.create(Curve.prototype);
CatmullRomCurve3.prototype.constructor=CatmullRomCurve3;
CatmullRomCurve3.prototype.getPoint=function(t,target){
target=target||new Vector3();
var P=this.points, n=P.length;
var l=this.closed?n:n-1;
var x=t*l, i=Math.floor(x); if(i>=l)i=l-1; var u=x-i;
function gp(k){ if(this.closed) return P[((k%n)+n)%n]; return P[Math.max(0,Math.min(n-1,k))]; }
var g=gp.bind(this);
var p0=g(i-1),p1=g(i),p2=g(i+1),p3=g(i+2);
function cr(a,b,c,d){
return 0.5*((2*b)+(-a+c)*u+(2*a-5*b+4*c-d)*u*u+(-a+3*b-3*c+d)*u*u*u);
}
return target.set(cr(p0.x,p1.x,p2.x,p3.x),cr(p0.y,p1.y,p2.y,p3.y),cr(p0.z,p1.z,p2.z,p3.z));
};
THREE.CatmullRomCurve3=CatmullRomCurve3;
THREE.TubeGeometry=function(path,tubularSegments,radius,radialSegments,closed){
tubularSegments=tubularSegments||64; radialSegments=radialSegments||8;
var pts=[],tans=[];
var segs=tubularSegments;
for(var i=0;i<=segs;i++){
var t=closed?(i%segs)/segs:i/segs;
pts.push(path.getPoint(t));
}
for(var i2=0;i2<=segs;i2++){
var t0=Math.max(0,i2-1), t1=Math.min(segs,i2+1);
tans.push(new Vector3().subVectors(pts[t1],pts[t0]).normalize());
}
var normals=[], n0=new Vector3(0,0,1);
if(Math.abs(tans[0].dot(n0))>0.9) n0=new Vector3(0,1,0);
var prev=new Vector3().crossVectors(tans[0],n0).normalize();
prev=new Vector3().crossVectors(prev,tans[0]).normalize();
for(var i3=0;i3<=segs;i3++){
var T=tans[i3];
var N=prev.clone();
var d=N.dot(T);
N.sub(T.clone().multiplyScalar(d)).normalize();
normals.push(N); prev=N;
}
return paramGeometry(function(pos,uv,idx){
for(var i4=0;i4<=segs;i4++){
var P=pts[i4], N=normals[i4], B=new Vector3().crossVectors(tans[i4],N).normalize();
for(var j=0;j<=radialSegments;j++){
var a=j/radialSegments*Math.PI*2, cx=Math.cos(a),sx=Math.sin(a);
pos.push(P.x+radius*(cx*N.x+sx*B.x), P.y+radius*(cx*N.y+sx*B.y), P.z+radius*(cx*N.z+sx*B.z));
uv.push(i4/segs,j/radialSegments);
}
}
for(var i5=0;i5<segs;i5++)for(var j2=0;j2<radialSegments;j2++){
var a2=i5*(radialSegments+1)+j2, b=(i5+1)*(radialSegments+1)+j2;
idx.push(a2,b,a2+1, b,b+1,a2+1);
}
});
};
function CanvasTexture(canvas){ this.canvas=canvas; this.isCanvasTexture=true; this._tid=_gid++; }
THREE.CanvasTexture=CanvasTexture;
function baseMat(p,flags){
p=p||{};
var m={
color:new Color(p.color!==undefined?p.color:0xffffff),
metalness:p.metalness!==undefined?p.metalness:0,
roughness:p.roughness!==undefined?p.roughness:0.5,
transmission:p.transmission||0,
thickness:p.thickness||0,
ior:p.ior||1.5,
clearcoat:p.clearcoat||0,
clearcoatRoughness:p.clearcoatRoughness||0,
envMapIntensity:p.envMapIntensity!==undefined?p.envMapIntensity:1,
side:p.side, transparent:!!p.transparent, opacity:p.opacity!==undefined?p.opacity:1,
map:p.map||null, depthWrite:p.depthWrite!==undefined?p.depthWrite:true,
emissive:p.emissive, emissiveIntensity:p.emissiveIntensity,
specularIntensity:p.specularIntensity
};
for(var k in flags) m[k]=flags[k];
return m;
}
THREE.MeshPhysicalMaterial=function(p){ return baseMat(p,{isPhysical:true}); };
THREE.MeshStandardMaterial=function(p){ return baseMat(p,{isStandard:true}); };
THREE.MeshBasicMaterial=function(p){ return baseMat(p,{isBasic:true}); };
THREE.ShadowMaterial=function(p){ return baseMat(p,{isShadow:true}); };
THREE.DoubleSide=2; THREE.BackSide=1; THREE.FrontSide=0;
THREE.ACESFilmicToneMapping=4; THREE.sRGBEncoding=3001;
THREE.PCFSoftShadowMap=2;
THREE.PMREMGenerator=function(){ };
THREE.PMREMGenerator.prototype.fromScene=function(){ return {texture:{isEnv:true}}; };
var VERT=[
"#version 300 es",
"precision highp float;",
"in vec3 position; in vec3 normal; in vec2 uv;",
"uniform mat4 uProj, uView, uModel;",
"uniform mat3 uNrm;",
"out vec3 vN; out vec3 vW; out vec2 vUv;",
"void main(){",
"  vec4 w=uModel*vec4(position,1.0);",
"  vW=w.xyz; vN=uNrm*normal; vUv=uv;",
"  gl_Position=uProj*uView*w;",
"}"].join("\n");
var TONE=[
"vec3 aces(vec3 x){",
"  return clamp((x*(2.51*x+0.03))/(x*(2.43*x+0.59)+0.14),0.0,1.0);",
"}",
"vec3 finish(vec3 c,float exposure){",
"  return pow(aces(c*exposure),vec3(1.0/2.2));",
"}"].join("\n");
var FRAG_METAL=[
"#version 300 es",
"precision highp float;",
"in vec3 vN; in vec3 vW;",
"uniform samplerCube uEnv;",
"uniform vec3 uCam, uColor;",
"uniform float uRough, uEnvInt, uExposure, uKey, uClear;",
"out vec4 frag;",
TONE,
"vec3 envS(vec3 d,float lod){ return textureLod(uEnv,d,lod).rgb*8.0; }",
"void main(){",
"  vec3 N=normalize(vN);",
"  vec3 V=normalize(uCam-vW);",
"  if(dot(N,V)<0.0) N=-N;",
"  vec3 R=reflect(-V,N);",
"  float NoV=clamp(dot(N,V),0.0,1.0);",
"  /* A METAL'S COLOUR *IS* ITS F0 — deriving it through a power curve washed every alloy toward",
"     chrome and the whole ring read as one silver-ish material with a tint painted on. And the",
"     grazing term runs to FULL white now (the 0.30 cap was flattening every rim): real polished",
"     metal burns bright along its silhouette edges, which is half of what makes it read as",
"     metal in a photograph instead of shaded plastic. */",
"  vec3 F0=uColor;",
"  vec3 F=F0+(vec3(1.0)-F0)*pow(1.0-NoV,5.0);",
"  /* the reflection in two layers: the mirror image, and the same image slightly blurred under",
"     it — the micro-scratch scatter of a real polish. Pure LOD-0 chrome is the CGI tell. */",
"  vec3 spec=mix(envS(R,uRough*5.0), envS(R,uRough*5.0+2.0), 0.32)*uEnvInt*F;",
"  vec3 col=spec;",
"  /* analytic studio pings — subordinate to the environment now: a soft core with a wide skirt",
"     instead of a hard white dot, which is how a softbox actually lands on curved metal */",
"  vec3 Ld[3]; float Li[3];",
"  Ld[0]=normalize(vec3(3.5,5.5,4.0)); Li[0]=uKey;",
"  Ld[1]=normalize(vec3(-4.0,3.0,3.0)); Li[1]=0.5;",
"  Ld[2]=normalize(vec3(0.0,2.0,-6.0)); Li[2]=0.6;",
"  float shin=mix(900.0,120.0,uRough*4.0);",
"  for(int i=0;i<3;i++){",
"    vec3 H=normalize(Ld[i]+V);",
"    float NoH=max(dot(N,H),0.0);",
"    col+=F0*(pow(NoH,shin)*1.15+pow(NoH,shin*0.10)*0.15)*Li[i];",
"    col+=F0*max(dot(N,Ld[i]),0.0)*0.020*Li[i];",
"  }",
"  /* clearcoat sheen: one crisp highlight, no second env wash (it was doubling the reflection) */",
"  vec3 Hc=normalize(Ld[0]+V);",
"  col+=vec3(pow(max(dot(N,Hc),0.0),1200.0))*uClear*0.9;",
"  frag=vec4(finish(col,uExposure),1.0);",
"}"].join("\n");
var FRAG_GEM=[
"#version 300 es",
"precision highp float;",
"in vec3 vN; in vec3 vW;",
"uniform samplerCube uEnv;",
"uniform vec3 uCam, uColor;",
"uniform float uExposure, uEnvInt, uTrans, uIOR, uKey;",
"out vec4 frag;",
TONE,
"vec3 envS(vec3 d,float lod){ return textureLod(uEnv,d,lod).rgb*8.0; }",
"float lum(vec3 c){ return dot(c,vec3(0.299,0.587,0.114)); }",
"void main(){",
"  vec3 N=normalize(vN);",
"  vec3 V=normalize(uCam-vW);",
"  if(dot(N,V)<0.0) N=-N;",
"  float NoV=clamp(dot(N,V),0.0,1.0);",
"  vec3 R=reflect(-V,N);",
"  float f0=pow((uIOR-1.0)/(uIOR+1.0),2.0);",
"  float F=f0+(1.0-f0)*pow(1.0-NoV,5.0);",
"  /* surface reflection, sharp */",
"  vec3 surf=envS(R,0.0);",
"  /* faked internal bounces: per-facet jittered refracted lobes */",
"  vec3 Ri=refract(-V,N,1.0/uIOR);",
"  if(length(Ri)<0.001) Ri=R;",
"  float white=step(0.98,uColor.g)*step(0.98,uColor.r);",
"  vec3 h=fract(N*vec3(13.73,9.21,7.53))-0.5;   /* constant per flat facet */",
"  vec3 j1=normalize(Ri+h*1.35);",
"  vec3 j2=normalize(reflect(Ri,N)+h.zxy*1.55);",
"  vec3 j3=normalize(Ri+h.yzx*2.40);",
"  /* PER-FACET WEIGHTS — the difference between a cut stone and frosted glass is CONTRAST:",
"     in a real brilliant, adjacent facets return completely different parts of the room, so",
"     some flash the softbox while their neighbours sit near-black. Equal-weight lobes were",
"     averaging every facet toward the same grey sparkle. */",
"  float w1=0.25+1.20*fract(h.x*7.91+0.37);",
"  float w2=0.25+1.20*fract(h.y*5.13+0.71);",
"  vec3 b1=envS(j1,0.0);",
"  vec3 b2=envS(j2,0.0);",
"  vec3 b3=envS(j3,0.5);",
"  vec3 internal=b1*0.58*w1+b2*0.58*w2+b3*0.22;",
"  internal*=1.0+pow(min(lum(internal)*0.45,1.6),3.0)*1.05;",
"  /* coloured stones: compress the hottest sparks (Reinhard on the overshoot) before the tint",
"     is applied — a spark 10x brighter than white burns straight through the body colour in the",
"     tonemapper and reads as a WHITE facet in a stone sold as Deep Blue */",
"  internal=mix(internal, internal/(1.0+0.22*max(lum(internal)-1.2,0.0)), (1.0-white)*0.85);",
"  /* dispersion / fire on bright internal sparks — wider spectral spread, earlier onset:",
"     the coloured fire is most of what says diamond rather than cubic glass */",
"  vec3 T=normalize(cross(N,V)+vec3(0.001));",
"  vec3 fr=envS(normalize(Ri+T*0.16),0.0);",
"  vec3 fb=envS(normalize(Ri-T*0.16),0.0);",
"  vec3 fire=vec3(fr.r,internal.g,fb.b);",
"  /* fire is spectral, but it still happens INSIDE the stone: a sapphire's sparks leave",
"     through blue glass, so a coloured stone tints its own fire before it reaches the eye */",
"  fire*=mix(vec3(1.0), uColor*1.15, (1.0-white)*0.85);",
"  float sparkle=smoothstep(0.70,2.2,lum(internal));",
"  internal=mix(internal,fire*1.35,0.65*sparkle);",
"  /* body colour: white stones stay bright, coloured stones absorb */",
"  vec3 deep=uColor*uColor;",
"  vec3 bodyC=deep*0.30+mix(uColor,deep,0.50)*internal*1.40;",
"  /* coloured stones keep their COLOUR: the old 0.35 floor let a third of the sparkle through",
"     untinted and every sapphire read baby-blue. A corundum's return trip is tinted, full stop. */",
"  vec3 body=mix(bodyC, internal*1.25, uTrans*0.92*max(white,0.12));",
"  body=mix(body, body*uColor, 1.0-white);",
"  /* surface glare: no flat floor (it milked every facet), and dialled back on coloured",
"     stones so the body colour owns the frame the way it does in a gem photograph */",
"  vec3 col=(body*(1.0-F*0.7)+surf*F*1.10*uEnvInt*mix(0.55,1.0,white))*0.70;",
"  /* hard glints from studio lights */",
"  vec3 Ld[2]; Ld[0]=normalize(vec3(3.5,5.5,4.0)); Ld[1]=normalize(vec3(-4.0,3.0,3.0));",
"  for(int i=0;i<2;i++){",
"    vec3 H=normalize(Ld[i]+V);",
"    col+=vec3(pow(max(dot(N,H),0.0),1400.0))*2.6*(i==0?uKey:0.5);",
"  }",
"  frag=vec4(finish(col,uExposure),1.0);",
"}"].join("\n");
var FRAG_BASIC=[
"#version 300 es",
"precision highp float;",
"in vec2 vUv;",
"uniform sampler2D uMap;",
"uniform float uOpacity;",
"out vec4 frag;",
"void main(){",
"  vec4 t=texture(uMap,vUv);",
"  frag=vec4(t.rgb,t.a*uOpacity);",
"}"].join("\n");
function WebGLRenderer(opts){
opts=opts||{};
var canvas=document.createElement("canvas");
var gl=canvas.getContext("webgl2",{
antialias:opts.antialias!==false, alpha:!!opts.alpha,
preserveDrawingBuffer:!!opts.preserveDrawingBuffer,
premultipliedAlpha:true
});
if(!gl) throw new Error("WebGL2 unavailable");
this.gl=gl; this.domElement=canvas;
this.toneMappingExposure=1;
this.outputEncoding=0; this.toneMapping=0;
this.shadowMap={enabled:false,type:0};
this._pr=1;
this._w=1; this._h=1;
this._progs={};
this._geoCache={};
this._texCache={};
this._buildPrograms();
this._buildEnv();
gl.enable(gl.DEPTH_TEST);
gl.disable(gl.CULL_FACE);
}
WebGLRenderer.prototype={
constructor:WebGLRenderer,
setPixelRatio:function(p){ this._pr=p; },
setSize:function(w,h){
this._w=w; this._h=h;
this.domElement.width=Math.round(w*this._pr);
this.domElement.height=Math.round(h*this._pr);
},
_compile:function(vs,fs){
var gl=this.gl;
function sh(type,src){
var s=gl.createShader(type);
gl.shaderSource(s,src); gl.compileShader(s);
if(!gl.getShaderParameter(s,gl.COMPILE_STATUS)) throw new Error("shader: "+gl.getShaderInfoLog(s));
return s;
}
var p=gl.createProgram();
gl.attachShader(p,sh(gl.VERTEX_SHADER,vs));
gl.attachShader(p,sh(gl.FRAGMENT_SHADER,fs));
gl.linkProgram(p);
if(!gl.getProgramParameter(p,gl.LINK_STATUS)) throw new Error("link: "+gl.getProgramInfoLog(p));
return p;
},
_buildPrograms:function(){
var gl=this.gl;
var defs=[["metal",FRAG_METAL],["gem",FRAG_GEM],["basic",FRAG_BASIC]];
for(var i=0;i<defs.length;i++){
var p=this._compile(VERT,defs[i][1]);
var u={}, n=gl.getProgramParameter(p,gl.ACTIVE_UNIFORMS);
for(var j=0;j<n;j++){ var info=gl.getActiveUniform(p,j); u[info.name]=gl.getUniformLocation(p,info.name); }
this._progs[defs[i][0]]={prog:p,u:u,
aPos:gl.getAttribLocation(p,"position"),
aNrm:gl.getAttribLocation(p,"normal"),
aUv:gl.getAttribLocation(p,"uv")};
}
},
_buildEnv:function(){
var gl=this.gl, SIZE=128;
function norm(x,y,z){ var l=Math.sqrt(x*x+y*y+z*z); return [x/l,y/l,z/l]; }
var lobes=[
{d:norm(0,1,0),      sx:0.48, sy:0.48, i:6.4, c:[1,1,1]},
{d:norm(0.75,0.72,0.75), sx:0.20, sy:0.34, i:6.0, c:[1,0.99,0.96]},
{d:norm(-1,0.30,0.42), sx:0.075, sy:0.52, i:4.6, c:[1,1,1]},
{d:norm(1,0.36,-0.24), sx:0.075, sy:0.46, i:4.0, c:[1,1,1]},
{d:norm(0,0.22,-1),  sx:0.40, sy:0.20, i:2.6, c:[0.96,0.97,1]},
{d:norm(-0.16,0.10,1), sx:0.30, sy:0.22, i:3.2, c:[1,1,1]},
{d:norm(0.10,0.50,0.86), sx:0.85, sy:0.085, i:3.6, c:[1,1,0.99]},
{d:norm(0.4,-0.65,0.4), sx:0.5, sy:0.5, i:0.45, c:[1,0.98,0.94]}
];
var flags=[
{d:norm(0.65,-0.05,0.75), sx:0.26, sy:0.38, k:0.70},
{d:norm(-0.75,0.05,-0.65), sx:0.30, sy:0.36, k:0.66},
{d:norm(-0.5,-0.15,0.85), sx:0.18, sy:0.30, k:0.60},
{d:norm(0.85,0.10,-0.45), sx:0.22, sy:0.30, k:0.55}
];
function frame(list){
for(var L=0;L<list.length;L++){
var d=list[L].d;
var up=Math.abs(d[1])>0.92?[1,0,0]:[0,1,0];
var t1=norm(up[1]*d[2]-up[2]*d[1], up[2]*d[0]-up[0]*d[2], up[0]*d[1]-up[1]*d[0]);
var t2=norm(d[1]*t1[2]-d[2]*t1[1], d[2]*t1[0]-d[0]*t1[2], d[0]*t1[1]-d[1]*t1[0]);
list[L].t1=t1; list[L].t2=t2;
}
}
frame(lobes); frame(flags);
function fall4(lo,dx,dy,dz){
var z=dx*lo.d[0]+dy*lo.d[1]+dz*lo.d[2];
if(z<=0) return 0;
var x=dx*lo.t1[0]+dy*lo.t1[1]+dz*lo.t1[2];
var y=dx*lo.t2[0]+dy*lo.t2[1]+dz*lo.t2[2];
var ex=x/(lo.sx*z), ey=y/(lo.sy*z);
return Math.exp(-(ex*ex*ex*ex+ey*ey*ey*ey))*z;
}
function radiance(dx,dy,dz){
var up=dy*0.5+0.5;
var r=0.028+0.19*up*up, g=r, b=r*1.03;
for(var L=0;L<lobes.length;L++){
var lo=lobes[L], v=lo.i*fall4(lo,dx,dy,dz);
r+=v*lo.c[0]; g+=v*lo.c[1]; b+=v*lo.c[2];
}
var mul=1;
for(var F=0;F<flags.length;F++){
mul*=1-flags[F].k*Math.min(1,fall4(flags[F],dx,dy,dz));
}
return [r*mul,g*mul,b*mul];
}
var tex=gl.createTexture();
gl.bindTexture(gl.TEXTURE_CUBE_MAP,tex);
var faces=[gl.TEXTURE_CUBE_MAP_POSITIVE_X,gl.TEXTURE_CUBE_MAP_NEGATIVE_X,
gl.TEXTURE_CUBE_MAP_POSITIVE_Y,gl.TEXTURE_CUBE_MAP_NEGATIVE_Y,
gl.TEXTURE_CUBE_MAP_POSITIVE_Z,gl.TEXTURE_CUBE_MAP_NEGATIVE_Z];
var buf=new Uint8Array(SIZE*SIZE*4);
for(var f=0;f<6;f++){
var o=0;
for(var j=0;j<SIZE;j++)for(var i=0;i<SIZE;i++){
var a=2*(i+0.5)/SIZE-1, b2=2*(j+0.5)/SIZE-1, dir;
switch(f){
case 0: dir=[ 1,-b2,-a]; break;
case 1: dir=[-1,-b2, a]; break;
case 2: dir=[ a, 1, b2]; break;
case 3: dir=[ a,-1,-b2]; break;
case 4: dir=[ a,-b2, 1]; break;
case 5: dir=[-a,-b2,-1]; break;
}
var l=Math.sqrt(dir[0]*dir[0]+dir[1]*dir[1]+dir[2]*dir[2]);
var c=radiance(dir[0]/l,dir[1]/l,dir[2]/l);
buf[o++]=Math.min(255,c[0]/8*255);
buf[o++]=Math.min(255,c[1]/8*255);
buf[o++]=Math.min(255,c[2]/8*255);
buf[o++]=255;
}
gl.texImage2D(faces[f],0,gl.RGBA,SIZE,SIZE,0,gl.RGBA,gl.UNSIGNED_BYTE,buf);
}
gl.generateMipmap(gl.TEXTURE_CUBE_MAP);
gl.texParameteri(gl.TEXTURE_CUBE_MAP,gl.TEXTURE_MIN_FILTER,gl.LINEAR_MIPMAP_LINEAR);
gl.texParameteri(gl.TEXTURE_CUBE_MAP,gl.TEXTURE_MAG_FILTER,gl.LINEAR);
this._envTex=tex;
},
_geoBuffers:function(geo){
var gl=this.gl;
var c=this._geoCache[geo.gid];
if(c && c.version===geo._version && !geo._disposed) return c;
if(c){ gl.deleteBuffer(c.pos); if(c.nrm)gl.deleteBuffer(c.nrm); if(c.uv)gl.deleteBuffer(c.uv); if(c.idx)gl.deleteBuffer(c.idx); }
function buf(target,data){
var b=gl.createBuffer(); gl.bindBuffer(target,b); gl.bufferData(target,data,gl.STATIC_DRAW); return b;
}
var out={version:geo._version};
out.pos=buf(gl.ARRAY_BUFFER,geo.attributes.position.array);
out.count=geo.attributes.position.array.length/3;
if(geo.attributes.normal) out.nrm=buf(gl.ARRAY_BUFFER,geo.attributes.normal.array);
if(geo.attributes.uv) out.uv=buf(gl.ARRAY_BUFFER,geo.attributes.uv.array);
if(geo.index){ out.idx=buf(gl.ELEMENT_ARRAY_BUFFER,new Uint32Array(geo.index)); out.icount=geo.index.length; }
this._geoCache[geo.gid]=out;
return out;
},
_tex2d:function(t){
var gl=this.gl;
if(this._texCache[t._tid]) return this._texCache[t._tid];
var tex=gl.createTexture();
gl.bindTexture(gl.TEXTURE_2D,tex);
gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,t.canvas);
gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR);
gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);
gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE);
gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE);
this._texCache[t._tid]=tex;
return tex;
},
render:function(scene,camera){
var gl=this.gl;
gl.viewport(0,0,this.domElement.width,this.domElement.height);
gl.clearColor(0,0,0,0);
gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER_BIT);
scene.updateWorldMatrix(null);
camera.updateLocal();
camera.updateProjectionMatrix();
var q=camera.quaternion, p=camera.position;
var inv=new Quaternion(-q.x,-q.y,-q.z,q.w);
var view=new Matrix4().compose(
new Vector3(-p.x,-p.y,-p.z).applyQuaternion(inv),
inv, new Vector3(1,1,1));
var keyI=1.5;
var meshes=[], blobs=[];
scene.traverse(function(o){
if(o.isLight && o.isSpot) keyI=o.intensity;
if(!o.isMesh || !o.visible) return;
var m=o.material;
if(!m || m.isShadow || m.isStandard) return;
if(m.isBasic) blobs.push(o); else meshes.push(o);
});
var self=this;
function nrmMat(model){
var e=model.e;
var a=e[0],b=e[1],c=e[2], d=e[4],f=e[5],g=e[6], h=e[8],i=e[9],j=e[10];
var det=a*(f*j-g*i)-d*(b*j-c*i)+h*(b*g-c*f);
if(Math.abs(det)<1e-12) det=1e-12;
var id=1/det;
return new Float32Array([
(f*j-g*i)*id, (h*i-d*j)*id, (d*g-h*f)*id,
(c*i-b*j)*id, (a*j-h*c)*id, (h*b-a*i)*id,
(b*g-c*f)*id, (d*c-a*g)*id, (a*f-d*b)*id
]);
}
function drawMesh(o,progName){
var P=self._progs[progName];
gl.useProgram(P.prog);
var bufs=self._geoBuffers(o.geometry);
gl.bindBuffer(gl.ARRAY_BUFFER,bufs.pos);
gl.enableVertexAttribArray(P.aPos);
gl.vertexAttribPointer(P.aPos,3,gl.FLOAT,false,0,0);
if(P.aNrm>=0){
if(bufs.nrm){ gl.bindBuffer(gl.ARRAY_BUFFER,bufs.nrm); gl.enableVertexAttribArray(P.aNrm); gl.vertexAttribPointer(P.aNrm,3,gl.FLOAT,false,0,0); }
else gl.disableVertexAttribArray(P.aNrm);
}
if(P.aUv>=0){
if(bufs.uv){ gl.bindBuffer(gl.ARRAY_BUFFER,bufs.uv); gl.enableVertexAttribArray(P.aUv); gl.vertexAttribPointer(P.aUv,2,gl.FLOAT,false,0,0); }
else gl.disableVertexAttribArray(P.aUv);
}
gl.uniformMatrix4fv(P.u.uProj,false,camera.projection.e);
gl.uniformMatrix4fv(P.u.uView,false,view.e);
gl.uniformMatrix4fv(P.u.uModel,false,o.matrixWorld.e);
if(P.u.uNrm) gl.uniformMatrix3fv(P.u.uNrm,false,nrmMat(o.matrixWorld));
if(P.u.uCam) gl.uniform3f(P.u.uCam,camera.position.x,camera.position.y,camera.position.z);
if(P.u.uExposure) gl.uniform1f(P.u.uExposure,self.toneMappingExposure);
if(P.u.uKey) gl.uniform1f(P.u.uKey,keyI);
var m=o.material;
if(P.u.uColor) gl.uniform3f(P.u.uColor,m.color.r,m.color.g,m.color.b);
if(P.u.uEnv){ gl.activeTexture(gl.TEXTURE0); gl.bindTexture(gl.TEXTURE_CUBE_MAP,self._envTex); gl.uniform1i(P.u.uEnv,0); }
if(P.u.uEnvInt) gl.uniform1f(P.u.uEnvInt,m.envMapIntensity);
if(P.u.uRough) gl.uniform1f(P.u.uRough,m.roughness);
if(P.u.uClear) gl.uniform1f(P.u.uClear,m.clearcoat);
if(P.u.uTrans) gl.uniform1f(P.u.uTrans,m.transmission);
if(P.u.uIOR) gl.uniform1f(P.u.uIOR,m.ior);
if(P.u.uMap && m.map){ gl.activeTexture(gl.TEXTURE1); gl.bindTexture(gl.TEXTURE_2D,self._tex2d(m.map)); gl.uniform1i(P.u.uMap,1); }
if(P.u.uOpacity) gl.uniform1f(P.u.uOpacity,m.opacity);
if(bufs.idx){ gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER,bufs.idx); gl.drawElements(gl.TRIANGLES,bufs.icount,gl.UNSIGNED_INT,0); }
else gl.drawArrays(gl.TRIANGLES,0,bufs.count);
}
gl.disable(gl.BLEND);
gl.depthMask(true);
for(var i=0;i<meshes.length;i++){
var m=meshes[i].material;
drawMesh(meshes[i], (m.transmission>0.05)?"gem":"metal");
}
gl.enable(gl.BLEND);
gl.blendFuncSeparate(gl.SRC_ALPHA,gl.ONE_MINUS_SRC_ALPHA,gl.ONE,gl.ONE_MINUS_SRC_ALPHA);
gl.depthMask(false);
for(var j=0;j<blobs.length;j++) drawMesh(blobs[j],"basic");
gl.depthMask(true);
gl.disable(gl.BLEND);
}
};
THREE.WebGLRenderer=WebGLRenderer;
global.THREE=THREE;
})(typeof self!=="undefined"?self:this);
